export const featurePages = [
  'ai-career-financial-analysis',
  'ai-career-path-guidance',
  'ai-generated-cover-letter',
  'ai-mock-interview',
  'ai-interview-question-generator',
  'cover-letter-review',
  'cover-letter-builder',
  'resume-builder',
  'resume-review',
  'linkedIn-builder',
  'higher-education',
  'pricing',
  'veterans',
];

export const cleanPathname = (pathname: string) => {
  return pathname.replace(/^\/|\/$/g, '');
};
